import { useState } from 'react';

import { Native } from '@givebacks/api';
import { usePlatformService } from 'core';
import { ClickableOptionsCard, TransferAccountsModalGroup } from 'core/Components';
import { Container, Stack, ThemeIcon } from 'ui';
import { IconLink, IconMobile, IconSecurityShield } from 'ui/Icons';

import { ProfileSettingsTemplate } from '../Profile/components/ProfileSettingsTemplate';
import { ManageMyCausesGroup } from './components/ManageMyCauses/ManageMyCausesGroup';
import { PrivacyModal } from './components/PrivacyModal';

const SettingsContent = () => {
  const Platform = usePlatformService();

  const [openModal, setOpenModal] = useState<
    'cause' | 'donation' | 'accounts' | 'privacy' | undefined
  >();
  return (
    <>
      <ProfileSettingsTemplate title="Settings">
        <Stack>
          <ClickableOptionsCard>
            <ManageMyCausesGroup />

            <TransferAccountsModalGroup
              openButton={(props) => (
                <ClickableOptionsCard.Row
                  onClick={() => props.openModalById('LinkedAccounts')}
                  leftSection={
                    <ThemeIcon variant="transparent" c="gray.2">
                      <IconLink />
                    </ThemeIcon>
                  }
                  title="Linked Accounts"
                />
              )}
            />
            {Platform.isNative && (
              <ClickableOptionsCard.Row
                onClick={() => Native.postMessage('Notifications')}
                leftSection={
                  <ThemeIcon variant="transparent" c="gray.2">
                    <IconMobile />
                  </ThemeIcon>
                }
                title="Givebacks Extension"
              />
            )}
            <ClickableOptionsCard.Row
              leftSection={
                <ThemeIcon variant="transparent" c="gray.2">
                  <IconSecurityShield />
                </ThemeIcon>
              }
              title="Privacy Settings"
              onClick={() => setOpenModal('privacy')}
            />
          </ClickableOptionsCard>
        </Stack>
      </ProfileSettingsTemplate>
      <PrivacyModal opened={openModal === 'privacy'} onClose={() => setOpenModal(undefined)} />
    </>
  );
};

const Settings = () => {
  return (
    <Container size="xl">
      <SettingsContent />
    </Container>
  );
};

export { Settings };
